import downloadFile from "../libs/DownloadFile";
import Fetcher from "../libs/Petition"

const url = '/provider_document_receiveds';
const CREATED = 201;
const STATUS_OK = 200;

/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param access_control_user_id Se utiliza el identificador del control de acceso para proveedores
 * @param page [Opcional] Se utiliza para conocer la página en la que se encuentra
 * @param pageSize [Opcional] Se utiliza para especificar el tamaño de la página, es decir, la cantidad de registros que se obtendrán.
 * @returns Object {"data" => ComplaintSuggestionBox::collection(),"totalItems" => Cantidad de registros existentes}
 */
export const indexProviderDocumentReceiveds = async (props) => {
    const {
        headers,
        access_control_user_id,
        page,
        pageSize } = props;
    let response = [];
    try {
        // Parámetros requeridos
        let params = { access_control_user_id };
        // Parámetros opcionales
        if (page) params.page = page;
        if (pageSize) params.pageSize = pageSize;
        let fetch = await Fetcher({
            url: `${url}`,
            method: 'GET',
            params,
            headers
        });
        // console.log("Fetcher complaints suggestions: ", fetch);
        if (fetch.status === STATUS_OK)
            response = fetch.data;
    } catch (error) {
        response = {
            data: [],
            totalItems: 0
        };
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param provider_document_received_id Identificador de la queja o sugerencia sobre el que se hará la consulta
 * @returns Incident Retorna un objeto tipo Incident
 */
export const showProviderDocumentReceiveds = async ({ headers, provider_document_received_id }) => {
    let response = [];
    try {
        let fetch = await Fetcher({
            url: `${url}/${provider_document_received_id}`,
            method: 'GET',
            headers
        });
        if (fetch.status === STATUS_OK)
            response = fetch.data.data;
    } catch (error) {
        response = {};
    } finally {
        return response;
    }
}
/**
 * 
 * @param data Contiene el objeto que se va a almacenar 
 * @returns Bool Retorna true si el objeto se almacena de manera satisfactoria, retorna FALSE si el objeto no se pudo almacenar 
 */
export const storeProviderDocumentReceiveds = async ({ data }) => {
    let response = true;
    try {
        let fetch = await Fetcher({
            url: `${url}`,
            method: 'POST',
            data
        });
        if (fetch.status !== CREATED)
            response = fetch.data;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param data Contiene el objeto que se va a actualizar
 * @param provider_document_received_id Identificador de la queja o sugerencia que se va a modificar
 * @returns Bool Retorna true si el objeto se actualiza de manera satisfactoria, retorna FALSE si el objeto no se pudo actualizar 
 */
export const updateProviderDocumentReceiveds = async ({ headers, data, provider_document_received_id }) => {
    let response = false;
    try {
        let fetch = await Fetcher({
            url: `${url}/${provider_document_received_id}`,
            method: 'PUT',
            data,
            headers
        });
        if (fetch.status === STATUS_OK)
            response = true;
        // console.log("Fetch complain suggestion: ", fetch);
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}
/**
 * 
 * @param headers Contiene la cabecera de autorización { Authorization: `Bearer ${token}` }
 * @param provider_document_received_id Identificador de la queja o sugerencia que se va a eliminar
 * @returns Bool Retorna true si el objeto se elimina de manera satisfactoria, retorna FALSE si el objeto no se pudo eliminar 
 */
export const destroyProviderDocumentReceiveds = async ({ headers, provider_document_received_id }) => {
    let response = true;
    try {
        let fetch = await Fetcher({
            url: `${url}/${provider_document_received_id}`,
            method: 'DELETE',
            headers
        });
        if (fetch.status !== STATUS_OK)
            response = false;
    } catch (error) {
        response = false;
    } finally {
        return response;
    }
}

export const downloadProviderDocumentReceiveds = async ({ headers, provider_document_received_id, name, toast }) => {
    try {
        downloadFile({
            headers,
            url: `${url}/download/${provider_document_received_id}`,
            type: 'application/json',
            name,
            toast
        });
    } catch (error) {
        console.log("Error: ", error);
    }
}